import { Navigate, Route, Routes } from 'react-router-dom'
import CGUPage from '../../pages/legal/CGU'
import CGAPage from '../../pages/legal/CGA'
import DataPrivacyPolicyPage from '../../pages/legal/DataPrivacyPolicy'
import { LayoutLegal } from '../../layout/LayoutLegal'
import LegalNoticesPage from '../../pages/legal/LegalNotices'

const LegalRoutes = () => {
  return (
    <Routes>
      <Route element={<LayoutLegal />}>
        <Route path="cgu" element={<CGUPage />} />
        <Route path="cga" element={<CGAPage />} />
        <Route path="legal-notice" element={<LegalNoticesPage />} />
        <Route path="data-privacy-policy" element={<DataPrivacyPolicyPage />} />
        <Route index path="*" element={<Navigate to={'cgu'} />} />
      </Route>
    </Routes>
  )
}

export default LegalRoutes
